export default {
  title: {
    id: 'buyback_offer_v2_faq_title',
    defaultMessage: 'FAQs',
  },
  subtitle: {
    id: 'buyback_offer_v2_faq_subtitle',
    defaultMessage: 'The questions people always ask',
  },
  howOfferCalculated: {
    id: 'buyback_offer_v2_faq_how_question',
    defaultMessage: 'How is my offer calculated?',
  },
  devicesEligible: {
    id: 'buyback_offer_v2_faq_devices_question',
    defaultMessage: 'What devices are eligible for Trade-in?',
  },
  prepareDevice: {
    id: 'buyback_offer_v2_faq_prepare_question',
    defaultMessage: 'How do I prepare my device before sending it?',
  },
  shipDevice: {
    id: 'buyback_offer_v2_faq_ship_device_question',
    defaultMessage: 'How do I ship my device?',
  },
  howLongToShip: {
    id: 'buyback_offer_v2_faq_how_long_to_ship_question',
    defaultMessage: 'How long do I have to send my device??',
  },
  dataOnDevice: {
    id: 'buyback_offer_v2_faq_data_on_device_question',
    defaultMessage: 'What happens to the data on my device?',
  },
  payment: {
    id: 'buyback_offer_v2_faq_payment_question',
    defaultMessage: 'How do I get paid?',
  },
  deviceAfterTradeIn: {
    id: 'buyback_offer_v2_faq_device_after_trade_in_question',
    defaultMessage: 'What happens to my device after trade-in?',
  },
  recycling: {
    id: 'buyback_offer_v2_faq_recycling_question',
    defaultMessage: 'Can I recycle my device instead?',
  },
  howOfferCalculatedAnswer: {
    id: 'buyback_offer_v2_faq_how_answer',
    defaultMessage:
      "Your offer is calculated based on your device's brand, model, storage capacity, condition, and current market value. We use real-time market data to ensure you get the best price.",
  },
  devicesEligibleAnswer: {
    id: 'buyback_offer_v2_faq_devices_answer',
    defaultMessage:
      'We accept smartphones, tablets, laptops, smartwatches, and other electronic devices from major brands. Check our device catalog to see if your specific model is eligible.',
  },
  prepareDeviceAnswer: {
    id: 'buyback_offer_v2_faq_prepare_answer',
    defaultMessage:
      'Before sending your device, make sure to back up your data, remove your SIM card, perform a factory reset, and remove any screen protectors or cases.',
  },
  shipDeviceAnswer: {
    id: 'buyback_offer_v2_faq_ship_device_answer',
    defaultMessage:
      "We'll provide you with a prepaid shipping label. Simply pack your device securely in the original box or a padded envelope and drop it off at any authorized shipping location.",
  },
  howLongToShipAnswer: {
    id: 'buyback_offer_v2_faq_how_long_to_ship_answer',
    defaultMessage:
      "You have 21 days from when you accept the offer to ship your device. We'll send you reminders to help you stay on track.",
  },
  dataOnDeviceAnswer: {
    id: 'buyback_offer_v2_faq_data_on_device_answer',
    defaultMessage:
      'We recommend backing up and erasing all personal data before sending your device. Once received, we securely wipe all data using industry-standard methods.',
  },
  paymentAnswer: {
    id: 'buyback_offer_v2_faq_payment_answer',
    defaultMessage:
      'Once we receive and verify your device, payment will be processed within 5 business days. You can choose between bank transfer or PayPal.',
  },
  deviceAfterTradeInAnswer: {
    id: 'buyback_offer_v2_faq_device_after_trade_in_answer',
    defaultMessage:
      'Your device will be professionally refurbished and resold, giving it a second life. This helps reduce electronic waste and makes technology more accessible.',
  },
  recyclingAnswer: {
    id: 'buyback_offer_v2_faq_recycling_answer',
    defaultMessage:
      "Yes! If your device isn't eligible for trade-in or you prefer recycling, we partner with certified recyclers to ensure your device is disposed of responsibly.",
  },
}
